<template>
	<div class="form-elements">
		<div class="row">
			<div class="col-md-12">
				<vuestic-widget headerText="Lista de Alunos por período">
					<div class="row">
						<div class="col-md-4">
							<DateIconGroup idInput="data-ini" iconInput="fa-calendar" labelInput="Data inicial">
							</DateIconGroup>
						</div>
						<div class="col-md-4">
							<DateIconGroup idInput="data-end" iconInput="fa-calendar" labelInput="Data final">
							</DateIconGroup>
						</div>
						<div class="col-md-4">
							<button @click="getListaAlunos()" class="btn btn-block btn-lg btn-secondary">Gerar</button>
						</div>
					</div>
				</vuestic-widget>

				<a href="#" hidden id="downloadListaDeAlunosPorPeriodo"></a>

				<div v-show="load">
					<div class="d-flex justify-content-center">
						<div class="btn-toolbar  d-inline-flex" role="toolbar" aria-label="Toolbar with button groups">
							<component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="80"></component>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import DateIconGroup from '@/vuestic-theme/vuestic-components/vuestic-input/DateIconGroup'
	import * as spinners from "epic-spinners"
	import urlApi from '../../router/urlApi'

	export default {
		name: "relatorioListaAlunosPorPeriodo",
		components: {
			...spinners,
			DateIconGroup
		},
		data() {
			return {
				load: false
			}
		},
		mounted() {
		},
		methods: {
			getListaAlunos() {
				var data_ini = document.getElementById("data-ini").value;
				var data_end = document.getElementById("data-end").value;

				if (data_ini == "") {
					document.getElementById("data-ini").focus();
					return false;
				}

				if (data_end == "") {
					document.getElementById("data-end").focus();
					return false;
				}

				this.load = true;
				const url = `${urlApi}/alunos/relatorio-lista-alunos-por-periodo/${data_ini}/${data_end}`;
				this.$http.get(url).then((res) => {
					console.log(res.data);
					var pdf = "data:application/octet-stream;base64," + res.data.dataPDF;
					var downloadPDF = document.getElementById("downloadListaDeAlunosPorPeriodo");
					downloadPDF.download = "relatorio-lista-de-alunos-por-periodo.pdf";
					downloadPDF.href = pdf;
					downloadPDF.click();
					this.load = false;
				});
			},
		}
	};
</script>